import { useTheme } from '@emotion/react';

export { useTheme };
